import { Box, Skeleton } from '@mui/material';
import React from 'react';

interface RestaurantImageSkeletonProps {
}

const RestaurantImageSkeleton: React.FC<RestaurantImageSkeletonProps> = ({ }) => {
    return (
        <Box borderRadius={1}>
            <Skeleton
                width={"100%"}
                sx={(theme) => ({
                    height: 128,
                    [theme.breakpoints.up("sm")]: {
                        height: 146
                    },
                    borderRadius: 1,
                })} />
        </Box>
    )
}

export default RestaurantImageSkeleton;